import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import "./Menu.css";

export default function Menu({ isOpen, onClose }) {
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const menuRef = useRef(null);

  const handleCloseMenu = useCallback(() => {
    setOpenSubmenu(null);
    onClose();
  }, [onClose]);

  const toggleSubmenu = (menu) => {
    setOpenSubmenu(openSubmenu === menu ? null : menu);
  };

  // Закрытие при клике вне меню
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        handleCloseMenu();
      }
    };

    if (isOpen) {
      document.body.classList.add("no-scroll"); // блокируем фон
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.body.classList.remove("no-scroll"); // разблокируем фон
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.classList.remove("no-scroll");
    };
  }, [isOpen, handleCloseMenu]);

  const handleMenuItemClick = () => {
    setOpenSubmenu(null);
    onClose();
  };

  const renderSubmenu = (menuName, links) => (
    <div className="navigation__submenu" key={menuName}>
      <button
        className="navigation__menu"
        onClick={(e) => {
          e.stopPropagation();
          toggleSubmenu(menuName);
        }}
      >
        {menuName}
      </button>
      <div
        className={`menu__dropdown-content ${
          openSubmenu === menuName ? "menu__dropdown-open" : ""
        }`}
      >
        {links.map(({ to, label }) => (
          <Link
            key={to}
            to={to}
            className="menu__content"
            onClick={handleMenuItemClick}
          >
            {label}
          </Link>
        ))}
      </div>
    </div>
  );

  return (
    <nav
      ref={menuRef}
      className={`navigation ${isOpen ? "navigation__open" : ""}`}
    >
      <button className="navigation__close" onClick={handleCloseMenu}></button>

      <div className="navigation__scroll">
        {renderSubmenu("Об институте", [
          { to: "/about", label: "Об институте" },
          { to: "/about/history", label: "История института" },
          { to: "/about/structure", label: "Структура института" },
          { to: "/about/managers", label: "Руководители" },
          { to: "/about/licenses", label: "Правовая информация и лицензии" },
          { to: "/about/privacy", label: "Политика конфиденциальности" },
          { to: "/about/anti-corruption", label: "Противодействие коррупции" },
          { to: "/about/controls", label: "Органы управления" },
          { to: "/about/vacancies", label: "Вакансии" },
          { to: "/about/news", label: "Новости" },
          { to: "/about/sitemap", label: "Карта сайта" },
          { to: "/about/working-conditions", label: "Условия труда" },
          { to: "/about/accounting-policy", label: "Учетная политика" },
          {
            to: "/about/independent-assessment",
            label: "Независимая оценка качества",
          },
          {
            to: "/about/heating-season",
            label: "Подготовка к отопительному сезону",
          },
        ])}

        {renderSubmenu("Наука", [
          {
            to: "/science",
            label: "Наука",
          },
          {
            to: "/science/research",
            label: "Научно-исследовательские разработки",
          },
          {
            to: "/science/development",
            label: "Разработка медицинских и организационных технологий",
          },
          { to: "/science/dissertation", label: "Диссертационный совет" },
          {
            to: "/science/clinical-trials",
            label: "Клинические испытания лекарственных средств",
          },
          { to: "/science/publications", label: "Научные публикации" },
          { to: "/science/scientific-research", label: "Научные исследования" },
          {
            to: "/science/certification",
            label: "Аттестация научных работников",
          },
          {
            to: "/science/patents",
            label: "Патенты",
          },
        ])}

        {renderSubmenu("Образование", [
          { to: "/education", label: "Образование" },
          { to: "/education/residency", label: "Ординатура" },
          { to: "/education/postgraduate-studies", label: "Аспирантура" },
          {
            to: "/education/additional",
            label: "Дополнительное профессиональное образование",
          },
          {
            to: "/education/teaching-staff",
            label: "Профессорско-преподавательский состав",
          },
          { to: "/education/admissions-committee", label: "Приемная комиссия" },
          {
            to: "/education/tax-deduction",
            label: "Налоговый вычет за платные образовательные услуги",
          },
        ])}

        {renderSubmenu("Клиника", [
          { to: "/clinic", label: "Клиника" },
          { to: "/clinic/hospital", label: "Стационар" },
          {
            to: "/clinic/specialized-medical",
            label: "Специализированная медицинская помощь",
          },
          {
            to: "/clinic/working-chief",
            label:
              "Работа с главными врачами кожно-венерологических учреждений",
          },
          {
            to: "/clinic/problem-syphilis",
            label: "Консультативный совет по проблеме сифилис",
          },
        ])}

        {renderSubmenu("Пациентам", [
          { to: "/patients", label: "Пациентам" },
          { to: "/patients/reception", label: "Прием специалистов" },
          { to: "/patients/reception-omc", label: "Прием специалистов ОМС" },
          { to: "/patients/working", label: "График работы" },
          //{ to: "/services", label: "Услуги" },
          { to: "/patients/pay", label: "Платные медицинские услуги" },
          { to: "/patients/price-list", label: "Прейскурант" },
          { to: "/patients/specialists", label: "Специалисты" },
          {
            to: "/patients/provision",
            label: "Оказание услуг гражданам в сфере здравоохранения",
          },
          { to: "/patients/participantsSVO", label: "Участникам СВО" },
          { to: "/patients/accessible-environment", label: "Доступная среда" },
          { to: "/patients/helplines", label: "Телефоны доверия" },
          { to: "/patients/fire-safety", label: "Пожарная безопасность" },
          {
            to: "/patients/clinical-examination",
            label: "Диспансеризация населения",
          },
          {
            to: "/patients/week",
            label:
              "Мероприятия по профилактике заболеваний и поддержке здорового образа жизни",
          },
          { to: "/patients/gosuslugi", label: "Госуслуги" },
          { to: "/patients/question-answer", label: "Вопрос–ответ" },
          { to: "/patients/reviews", label: "Отзывы" },
          {
            to: "/patients/emergency-numbers",
            label: "Телефоны справочных служб",
          },
        ])}

        <div className="navigation__submenu">
          <Link
            to="/contacts"
            className="navigation__menu"
            onClick={handleMenuItemClick}
          >
            Контакты
          </Link>
        </div>

        <div className="navigation__submenu">
          <Link
            to="/#record"
            className="navigation__menu"
            onClick={handleMenuItemClick}
          >
            Запись на прием
          </Link>
        </div>

        <div className="navigation__submenu">
          <a
            href="tel:+73432189586"
            className="navigation__menu"
            onClick={handleMenuItemClick}
          >
            Позвонить
          </a>
        </div>
      </div>
    </nav>
  );
}
